import { BLESS_API_BASE_URL, BLESS_API_TEST_BASE_URL } from "@/constants/api.constants";
import { HealthResponse } from "@/types/health.types";
import { isMainnet } from "@/constants/flags.constant";

export class HealthService {
  private static getBaseUrl(): string {
    return isMainnet ? BLESS_API_BASE_URL : BLESS_API_TEST_BASE_URL;
  }

  static async getHealthStatus(): Promise<HealthResponse> {
    const baseUrl = this.getBaseUrl();
    const response = await fetch(`${baseUrl}/health`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      // Disable caching to get real-time status
      cache: 'no-store',
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch health status: ${response.status} ${response.statusText}`);
    }

    return response.json();
  }
}

